import React from 'react';
import PropTypes from 'prop-types';
import { Validate, ErrorMessage } from '../../../../components/Validation';
import Select from 'react-select';
import { FormattedMessage, injectIntl } from 'react-intl';
import { required } from '../../../../utils/validation/validator';

const ExpenseForSelect = ({
  validatorGroup,
  validationCounter,
  defaultValue,
  disabled,
  options,
  classNamePrefix,
  onChange,
  value,
  fieldName,
  tooltipContent,
  messages,
  placeholder,
  intl,
}) => (
  <Validate
    name="expenseFor"
    validators={[required]}
    group={validatorGroup}
    addValidatorToGroup={validatorGroup.addValidatorToGroup}
    validChangeInGroup={validatorGroup.validChangeInGroup}
    validationCounter={validationCounter}
    validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
    defaultValue={defaultValue}
    fieldName={fieldName}
    tooltipContent={tooltipContent}
    tooltipDataFor="expenseForHint"
  >
    <Select
      name="expenseFor"
      isMulti
      isDisabled={disabled}
      options={options}
      placeholder={placeholder}
      className="react-select-container"
      classNamePrefix={classNamePrefix}
      onChange={onChange}
      value={value}
      getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
      getOptionValue={(option) => option.policyRoleID}
    />
    <ErrorMessage for="required">
      <FormattedMessage
        {...messages.isRequired}
        values={{ 
          defaultMessage: (() => {
            // Try messages.expenseFor first
            if (messages.expenseFor && messages.expenseFor.id) {
              return intl.formatMessage(messages.expenseFor);
            }
            // Fallback to fieldName if it's a message object
            if (fieldName && typeof fieldName === 'object' && fieldName.id) {
              return intl.formatMessage(fieldName);
            }
            // Fallback to string fieldName or default
            return fieldName || 'Expense For';
          })()
        }}
      />
    </ErrorMessage>
  </Validate>
);

ExpenseForSelect.propTypes = {
  name: PropTypes.string.isRequired,
  validators: PropTypes.array,
  validatorGroup: PropTypes.object.isRequired,
  validationCounter: PropTypes.number,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  classNamePrefix: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  fieldName: PropTypes.string,
  tooltipContent: PropTypes.string,
  tooltipDataFor: PropTypes.string,
  messages: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

ExpenseForSelect.defaultProps = {
  validators: [],
  disabled: false,
  options: [],
  placeholder: 'Select',
  classNamePrefix: 'react-select',
  getOptionLabel: (option) => option.label,
  getOptionValue: (option) => option.value,
};

export default injectIntl(ExpenseForSelect);



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/ExpenseForSelect/index.js